import * as constants from "./actions";
import axios from "@/plugins/axios.js";

function getDefaultState() {
  return {
    providers: {
      status: null,
      data: null,
      error: null,
    },

    provider: {
      status: null,
      data: null,
      error: null,
    },
  };

}

const actions = {
  [constants.GET_PROVIDERS]: async ({ commit }, params) => {
    try {
      commit(constants.GET_PROVIDERS);

      const response = await axios.get(`supplier/getSupplier`, { params: { ...params } });
      commit(constants.GET_PROVIDERS_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_PROVIDERS_ERROR, error);
      throw error.response;
    }
  },
  [constants.POST_PROVIDER]: async ({ commit }, payload) => {
    try {
      commit(constants.POST_PROVIDER);
      const response = await axios.post(`supplier/createAndUpdateSupplier`, payload);
      commit(constants.POST_PROVIDER_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.POST_PROVIDER_ERROR, error);
      throw error.response;
    }
  },
}

const mutations = {
  [constants.GET_PROVIDERS](state) {
    state.providers.status = "fetching";
  },
  [constants.GET_PROVIDERS_SUCCESS](state, response) {
    state.providers.status = "success";
    state.providers.data = response.data;
  },
  [constants.GET_PROVIDERS_ERROR](state, error) {
    state.providers.status = "error";
    state.providers.error = error;
  },
  [constants.POST_PROVIDER](state) {
    state.provider.status = "fetching";
  },
  [constants.POST_PROVIDER_SUCCESS](state, response) {
    state.provider.status = "success";
    state.provider.data = response.data;
  },
  [constants.POST_PROVIDER_ERROR](state, error) {
    state.provider.status = "error";
    state.provider.error = error;
  },
};

export default {
  state: getDefaultState(),
  actions,
  mutations,
};